import { Form, Formik } from 'formik'
import { InputField, InputSelectOptions } from 'components'
import { GENDER } from 'domains/user/constants/user-constants'
import { profileSchema } from './user-profile-schema'
import PropTypes from 'prop-types'
import LoaderButton from 'components/molecules/loader-button'
import { DateInputField, ToggleField } from 'components'
import { Button } from 'reactstrap'
import { useState } from 'react'
import TimeUtil from 'utils/time-util'

const propTypes = {
  user             : PropTypes.object,
  handleSubmitForm : PropTypes.func
}

const defaultProps = {
  user             : {},
  handleSubmitForm : () => { }
}

const UserProfileForm = ({
  user,
  handleSubmitForm
}) => {

  const [ isEmailEdit, setIsEmailEdit ]                 = useState(false)
  const [ isDeletedStasusEdit, setIsDeletedStasusEdit ] = useState(false)

  const editButtonName  = isEmailEdit ? 'Cancel' : 'Edit'
  const editButtonColor = isEmailEdit ? 'danger' : 'info'

  const handleOnclickEvent = (setFieldValue) => {
    setIsEmailEdit(!isEmailEdit)

    // back to initial value if not editing email
    if (isEmailEdit) {
      setFieldValue('email',user?.email ?? '')
      setFieldValue('reason_note', '')
      setFieldValue('validate_by','')
    }

  }

  const handleToggleEditDeletedStatus = (formik) => {
    const editToggle = formik.values.is_deleted == user?.is_deleted
    setIsDeletedStasusEdit(editToggle)
  }


  return (
    <Formik
      enableReinitialize={ true }
      initialValues={{
        name                : user?.name ?? '',
        email               : user?.email ?? '',
        mobile              : user?.mobile ?? '',
        birthday            : user?.birthday ?? '',
        gender              : user?.gender ?? '',
        is_deleted          : user?.is_deleted ?? false,
        email_reason_note   : '',
        email_validate_by   : '',
        deleted_reason_note : '',
        deleted_validate_by : ''
      }}
      validationSchema={ profileSchema(isEmailEdit, isDeletedStasusEdit) }
      onSubmit={ handleSubmitForm }
    >
      {
        (formik) => (
          <>
            <Form>
              <InputField
                type='text'
                name='name'
                label='Name'
                required={ true }
              />

              <Button
                className='float-right mb-1'
                color={ editButtonColor }
                onClick={ () => handleOnclickEvent(formik.setFieldValue) }
              >
                { editButtonName }
              </Button>
              <InputField
                type='text'
                name='email'
                label='Email'
                formText='Email bisa diubah dengan cara klik "Edit"'
                disabled={ !isEmailEdit }
                required={ true }
              />
              {
                isEmailEdit && (
                  <>
                    <InputField
                      type='text'
                      name='email_reason_note'
                      label='Reason Note'
                      formText='Tuliskan alasan user mengajukan perubahan email. Contoh: Typo dalam penulisan email'
                      disabled={ !isEmailEdit }
                      required={ true }
                    />
                    <InputField
                      type='text'
                      name='email_validate_by'
                      label='Validate By'
                      formText= "Mohon konfirmasi jika yang mengajukan perubahan email adalah pemilik akun, seperti menanyakan nomor telp, tanggal lahir, akun bank, dll. Contoh: User menghubungi team CS menggunakan nomor telpon sesuai dengan akun yang ingin diubah"
                      disabled={ !isEmailEdit }
                      required={ true }
                    />
                  </>
                )
              }
              <InputField
                type='tel'
                name='mobile'
                label='Mobile No.'
                formText='Angka [0-9], Contoh: 6281234567890'
                required={ true }
              />
              <DateInputField
                label='Birthday'
                name='birthday'
                dateFormat="dd/MM/yyyy"
                maxDate={ new Date() }
                required={ false }
                formText='format: dd/mm/yy'
              />

              <InputField
                type='select'
                name='gender'
                label='Gender'
                required={ true }
              >
                <InputSelectOptions options={ GENDER } keyPrefix={ 'gender' } />
              </InputField>



              <ToggleField
                id={ 'is_deleted' }
                name={ 'is_deleted' }
                label={ 'Is Deleted?' }
                onClick={ () => handleToggleEditDeletedStatus(formik) }
                required={ true }
                formText={ <>
                  <strong> Akun terhapus pada { TimeUtil.format(user.deleted_at) || '-' }</strong>
                  <br/>
                  <strong>Yes: </strong>User akan di Ban permanen dari proses Inbound, Outbound, ataupun transaksi jual beli di Tinkerlust.
                  <br/>
                  <strong>No: </strong>User tidak di Ban dari TInkerlust. User dapat melakukan transaksi jual beli apapun di Tinkerlust
                  <br />
                </> }
              />

              {
                isDeletedStasusEdit && (
                  <>
                    <InputField
                      type='text'
                      name='deleted_reason_note'
                      label='Reason Note'
                      formText='Tuliskan alasan user mengajukan perubahan status delete. Contoh: permintaan dari user'
                      disabled={ !isDeletedStasusEdit }
                      required={ true }
                    />
                    <InputField
                      type='text'
                      name='deleted_validate_by'
                      label='Validate By'
                      formText= "Mohon konfirmasi jika yang mengajukan perubahan status delete adalah pemilik akun, seperti menanyakan nomor telp, tanggal lahir, akun bank, dll. Contoh: User menghubungi team CS menggunakan nomor telpon sesuai dengan akun yang ingin diubah"
                      disabled={ !isDeletedStasusEdit }
                      required={ true }
                    />
                  </>
                )
              }


              <LoaderButton
                className='float-right'
                color='success'
                isLoading={ formik.isSubmitting }
                type="submit"
                text={ 'Save' }
              />
            </Form>
          </>
        )
      }
    </Formik>
  )
}

UserProfileForm.propTypes    = propTypes
UserProfileForm.defaultProps = defaultProps

export default UserProfileForm
